import { Box, Drawer, IconButton } from '@mui/material';
import { useMemo } from 'react';
import { useRecapContext } from './useRecapContext.hook';
import { useMobile } from '@act/utilities/MobileContext';
import { useDisplayModeContext } from '../display';
import {
  COMPACT_GRID_WIDTH,
  EXPANDED_GRID_WIDTH,
} from '@act/react-components/app/constants';
import { FlexContainer, IconLibrary } from '@act/storybook';
import { Slideshow } from '@act/storybook';
import { RecapSlides } from './slides/RecapSlides';

export const RecapDrawer = () => {
  const { isMobile } = useMobile();
  const { isDrawerOpen, closeDrawer } = useRecapContext();
  const { displayMode } = useDisplayModeContext();

  const marginLeft =
    displayMode === 'compact' ? COMPACT_GRID_WIDTH : EXPANDED_GRID_WIDTH;
  const drawerWidth = `calc(100vw - ${marginLeft})`;

  // Placeholder slides - replace with actual content
  const slides = useMemo(() => RecapSlides, []);

  const autoAdvanceInterval = useMemo(() => {
    return [4500, 8000, 3500, isMobile ? 6500 : 18750, 0];
  }, [isMobile]);

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={closeDrawer}
      anchor="right"
      PaperProps={{
        sx: {
          width: isMobile ? '100%' : drawerWidth,
          boxSizing: 'border-box',
        },
      }}
    >
      <FlexContainer
        direction="row"
        height="100%"
        width="100%"
        sx={{ position: 'relative', boxSizing: 'border-box' }}
      >
        <Box sx={{ position: 'absolute', top: 24, right: 24 }}>
          <IconButton onClick={closeDrawer} sx={{ marginLeft: 'auto' }}>
            <IconLibrary iconName="X" weight="bold" size={40} />
          </IconButton>
        </Box>
        <Slideshow
          slides={slides}
          autoAdvanceInterval={autoAdvanceInterval}
          isActive={isDrawerOpen}
        />
      </FlexContainer>
    </Drawer>
  );
};
